import { FeatureFlag } from '../constants/featureFlags';
import { useStore } from '../store';
import {
  agencyHasExternalEmr,
  useAgencyHasExternalEmr,
} from './useExternalEmrImport';

type TakeOverAgency = Parameters<typeof agencyHasExternalEmr>[0];

/**
 * Whether this agency gets Take Over v2: an External EMR and the Take Over
 * flag. Off, the agency keeps the basic Take Over from Add Episode, as on
 * main. Mirrors the server's `take_over_available`.
 */
export function agencyHasTakeOver(
  agency: TakeOverAgency,
  takeOverFlagOn: boolean
): boolean {
  return agencyHasExternalEmr(agency) && takeOverFlagOn;
}

/** {@link agencyHasTakeOver} for the signed-in user's agency. */
export function useTakeOverAvailable(): boolean {
  const hasExternalEmr = useAgencyHasExternalEmr();
  const takeOverFlagOn = useStore(state =>
    state.hasFeatureFlag(FeatureFlag.EXTERNAL_EMR_TAKE_OVER, 'workos')
  );
  return hasExternalEmr && takeOverFlagOn;
}
